import './popupApprovazioneFerie.scss';

import React, { useState, useImperativeHandle, useEffect, useRef } from "react";
import { Popup, Form, Button } from "devextreme-react";
import { Position, ToolbarItem } from "devextreme-react/popup";
import { FormRef, Item } from "devextreme-react/form";
import { useScreenSize } from "../../utils/media-query";

import useApiConfiguration from "../../apiConfig";
import { ApprovazioniApi, RichiesteCausaliCDLApi, RichiesteCausaliCdlResponseDTO } from "../../data";

export type PopupApprovazioneFerieHandle = {
    show: (id: number) => void
};

type Props = {
    onChange: () => void
};

type State = {
    id: number | undefined,
    visible: boolean
};

const PopupApprovazioneFerie: React.ForwardRefRenderFunction<PopupApprovazioneFerieHandle, Props> = (props, ref) => {
    const formRef = useRef<FormRef>(null);
    const apiConfiguration = useApiConfiguration();
    const { isLarge } = useScreenSize();

    const [state, setState] = useState<State>({ id: undefined, visible: false });
    const [formData, setFormData] = useState<RichiesteCausaliCdlResponseDTO>();
    const [giornoSingolo, setGiornoSingolo] = useState<boolean>(false);
    const [daApprovare, setDaApprovare] = useState<boolean>(true);
    const [testoApprovazione, setTestoApprovazione] = useState<string>("");

    useImperativeHandle(ref, () => ({
        show(id) {
            setState({ id: id, visible: true });
        }
    }));

    function hideInfo() {
        setState({ id: undefined, visible: false });
    };

    useEffect(() => {
        if (state.visible && state.id) {
            var api = new RichiesteCausaliCDLApi(apiConfiguration);

            api.getRichiestaCausaleCdL({
                id: state.id
            }).then((data) => {
                if (data) {
                    setFormData({
                        ...data,
                        id: state.id
                    });

                    setGiornoSingolo(data.ore != null);
                    setDaApprovare(data.approvatoIl == null);
                    setTestoApprovazione(data.approvatoIl == null ? "" : (data.approvazione === "Approvato" ? "Approvato il" : "Rifiutato il"));
                }
            });
        }
    }, [state.id, state.visible]);

    const scegliEsito = (approvato: boolean) => {
        var api = new ApprovazioniApi(apiConfiguration);
        api.putApprovaRichiestaCausaleCdlStorico({
            id: state.id,
            isApprovata: approvato,
            note: formData?.noteApprovatore || ''
        })
        .then(() => props.onChange())
        .catch((error) => console.error(error))
        .finally(() => hideInfo());
    };

    return (
        <React.Fragment>
            <Popup
                visible={state.visible}
                dragEnabled={false}
                hideOnOutsideClick
                showCloseButton showTitle
                fullScreen={false}
                title="Dettaglio Richiesta Ferie"
                container=".dx-viewport"
                height={"auto"}
                onHidden={hideInfo}
            >
                <Position at="center" my="center" of="" collision="fit" />

                <ToolbarItem widget="dxButton" toolbar="bottom" location="center">
                    <Button
                        icon="check"
                        text="Approva"
                        type="success"
                        stylingMode="contained"
                        visible={daApprovare}
                        onClick={() => scegliEsito(true)}
                    />
                </ToolbarItem>

                <ToolbarItem widget='dxButton' toolbar='bottom' location='center'>
                    <Button 
                        icon="close"
                        text="Rifiuta"
                        type="danger"
                        stylingMode="contained"
                        visible={daApprovare}
                        onClick={() => scegliEsito(false)}
                    />
                </ToolbarItem>

                <Form ref={formRef} formData={formData} labelMode="floating" colCount={ isLarge ? 2 : 1 } id="form-approvazione-ferie">
                    <Item visible={false} dataField="idRichiedente" />
                    <Item visible={false} dataField="idCausaleRichiesta" />

                    {
                        !daApprovare && (
                            <React.Fragment>
                                <Item colSpan={1} dataField='approvazione' label={{ text: "Stato Richiesta" }} editorType='dxTextBox' editorOptions={{ disabled: true }} />
                                <Item colSpan={1} dataField='approvatore' editorType='dxTextBox' editorOptions={{ disabled: true }} />
                                <Item colSpan={1} dataField='approvatoIl' editorType='dxDateBox' label={{ text: testoApprovazione }}
                                    editorOptions={{
                                        type: "date",
                                        displayFormat: isLarge ? "EEEE d MMMM yyyy" : "dd/MM/yyyy",
                                        disabled: true
                                    }}
                                />

                                { isLarge && <Item colSpan={1} itemType='empty' /> }
                            </React.Fragment>
                        )
                    }

                    <Item colSpan={1} dataField='richiedente' editorType='dxTextBox' editorOptions={{ disabled: true }} />
                    <Item colSpan={1} dataField='causale' editorType='dxTextBox' editorOptions={{ disabled: true }} />

                    {
                        giornoSingolo && (
                            <React.Fragment>
                                <Item colSpan={1} dataField="daData" label={{ text: "Data" }} editorType="dxDateBox"
                                    editorOptions={{
                                        type: "date",
                                        displayFormat: isLarge ? "EEEE d MMMM yyyy" : "dd/MM/yyyy",
                                        disabled: true
                                    }}
                                />

                                <Item colSpan={1} dataField="ore" label={{ text: "Ore Richieste" }} editorType="dxNumberBox"
                                    editorOptions={{
                                        disabled: true
                                    }}
                                />
                            </React.Fragment>
                        )
                    }

                    {
                        !giornoSingolo && (
                            <React.Fragment>
                                <Item colSpan={1} dataField='daData' label={{ text: "Data Da" }} editorType='dxDateBox'
                                    editorOptions={{
                                        type: "date",
                                        displayFormat: isLarge ? "EEEE d MMMM yyyy" : "dd/MM/yyyy",
                                        disabled: true
                                    }}
                                />

                                <Item colSpan={1} dataField='aData' label={{ text: "Data A" }} editorType='dxDateBox'
                                    editorOptions={{
                                        type: "date",
                                        displayFormat: isLarge ? "EEEE d MMMM yyyy" : "dd/MM/yyyy",
                                        disabled: true
                                    }}
                                />
                            </React.Fragment>
                        )
                    }

                    <Item colSpan={isLarge ? 2 : 1} dataField="note" label={{ text: "Note Richiesta" }}
                        editorType="dxTextArea" cssClass="dx-textarea-custom"
                        editorOptions={{
                            maxLength: 1500,
                            autoResizeEnabled: true,
                            disabled: true
                        }}
                    />

                    <Item colSpan={isLarge ? 2 : 1} dataField="noteApprovatore" 
                        editorType="dxTextArea" cssClass="dx-textarea-custom"
                        editorOptions={{
                            maxLength: 1500,
                            autoResizeEnabled: true,
                            disabled: !daApprovare
                        }}
                    />
                </Form>
            </Popup>
        </React.Fragment>
    );
};

export default React.forwardRef(PopupApprovazioneFerie);